import { render, staticRenderFns } from "./LogsManutencaoPonto.vue?vue&type=template&id=5479b527&"
import script from "./LogsManutencaoPonto.vue?vue&type=script&lang=js&"
export * from "./LogsManutencaoPonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports